// --------------------------------------------------
//   Imports
// --------------------------------------------------

// React
import { useState, useEffect, useRef } from 'react';

// Material UI
import {
  Box,
} from "@mui/material";



// --------------------------------------------------
//   Component
// --------------------------------------------------

let contentType = null;

export default function WebcamVideo({ videoRef, on = false, onStart }) {

  // Create reference for canvas element
  const canvasRef = useRef(null);

  useEffect(() => {
    if (on) {
      startWebcam()
        .then(() => onStart())
        .catch((err) => onStart(err))
    }
  }, [on])

  useEffect(() => {
    const $canvas  = canvasRef.current;
    const width    = $canvas.parentElement.getBoundingClientRect().width;
    $canvas.width  = width;
    $canvas.height = width * 3 / 4;
  })


  async function startWebcam() {

    // Get the child elements by reference
    const $webcam = videoRef.current;
    const $canvas = canvasRef.current;
  
    const constraints = {
      audio: {
        sampleRate: 44000,
        echoCancellation: false,
        noiseSuppression: false,
      },
      video: {
        facingMode: "user",
      },
    }
  
    // Attach camera to webcam stream video element
    const webcamStream = await navigator.mediaDevices.getUserMedia(constraints);
    $webcam.srcObject = webcamStream;
  
    // Get the canvas context
    const ctx = $canvas.getContext('2d');
  
    // Render video in canvas
    $webcam.addEventListener('canplay', (event) => {
      console.log("CAN PLAY");
      $webcam.play();

      // Use the video aspect ratio to compute the canvas height
      const aspectRatio = $webcam.videoWidth / $webcam.videoHeight;

      // Fit the canvas into its parent element
      let width  = $canvas.parentElement.getBoundingClientRect().width;
      let height = width / aspectRatio;

      // Set the canvas dimensions to the computed values
      $canvas.width  = width;
      $canvas.height = height;

      // Update width and height on window resize to keep canvas size correct
      window.addEventListener('resize', () => {

        // Fit the canvas into its parent element
        width = $canvas.parentElement.getBoundingClientRect().width;
        height = width / aspectRatio;

        // Set the canvas dimensions to the computed values
        $canvas.width  = width;
        $canvas.height = height;
      })

      // Set up the animation loop
      const draw = () => {
        ctx.drawImage($webcam, 0, 0, width, height);
        requestAnimationFrame(draw);
      }
      requestAnimationFrame(draw);
    });
  }

  // Update the global content type to a supported type,
  // or throw an error if none of them are supported
  // contentType = getFirstSupportedType([ "video/mp4", "video/webm" ]);
  contentType = "video/mp4";
  console.log("Browser supports: ", contentType)

  return (
    <Box width="100%" backgroundColor="black">
      <video
        ref         = { videoRef }
        style       = {{"zIndex": "-999", "display": "none", "position": "absolute" }}
        autoPlay    = {true}
        muted       = {true}
        playsInline = {true}
        controls    = {true}
      ></video>
      <canvas ref={ canvasRef }></canvas>
    </Box>
  )
}
